import React from 'react';
import './MortbuzzHomeLoan.css';
import 'animate.css/animate.min.css';
import Seo from "../components/Seo";



function MortbuzzHomeLoan(){
  return (
    <>
    <Seo
        title="Home Loan in Pune – Low Interest Rates & Quick Approval | Mortbuzz"
        description="Apply for a Home Loan in Pune with Mortbuzz and get the lowest interest rates, easy documentation, and quick approvals. Perfect for salaried and self-employed borrowers."
        keywords="Home Loan in Pune, best home loan consultant, low interest home loan, home loan eligibility, apply home loan online"
        canonical="https://www.mortbuzz.in/mortbuzz-home-loan"
      />



      {/* Meta tags (use react-helmet if needed) */}
      {/* Hero Section */}
      <section className="mortbuzzhheroHome position-relative d-flex flex-column justify-content-center">
        <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
        <div className="container">
          <h1 className="animate__animated animate__fadeInDown">Build Your Dream Home loan in Pune with MortBuzz</h1>
          <p className="lead animate__animated animate__fadeInUp animate__delay-1s">Find the best home loan in Pune solutions tailored for you.</p>
          <a href="apply-now" className="apply-btn-glass mt-4 animate__animated animate__fadeInUp animate__delay-2s">Apply Now</a>
        </div>
      </section>

      {/* Followed by the rest of your sections: About, Uses, Eligibility, etc. Copy & paste JSX parts section-by-section here */}
      <section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img
                  src="/images/FrontPage/home-loan-mortbuzz.jpg"
                  className="img-fluid rounded shadow animate__animated animate__fadeInLeft"
                  alt="Dream House"/>

            </div>
            <div className="col-lg-6 text-white">
                <h2 className="mb-4 text-white ">Why Choose MortBuzz for Your Home Loan in Pune ?</h2>
                <p>Home ownership is within your reach! Whether you wish to buy, construct, renovate, or expand — we make it easy and affordable with unmatched market insights and end-to-end support.</p>
                <ul className="list-unstyled mt-3">
                    <li>✅ Low Interest Rate Home Loan In Pune 7.35%*</li>
                    <li>✅ High Loan Amounts</li>
                    <li>✅ 360-Degree Assistance</li>
                    <li>✅ Zero Processing Fees on Selected Banks</li>
                    <li>✅ Upto 100% Cashback on Charges</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Instant Home Loan Approval</li>
                </ul>
            </div>
        </div>
    </div>
</section>


{/*!-- Loan Uses -->*/}
<section className="section bg-light">
    <div className="container text-center">
        <h2 className="mb-5">Uses of a Home Loan</h2>
        <div className="row g-4">
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>New House Purchase</h5>
                    <p>Own your dream house with maximum financing support.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-1s">
                    <h5>Renovation or Extension</h5>
                    <p>Upgrade your home smartly without draining your savings.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Top-up Loans</h5>
                    <p>Access extra funds over your existing home loan at attractive rates.</p>
                </div>
            </div>
        </div>
    </div>
</section>


{/*<!-- Eligibility Criteria -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Home Loan in Pune Eligibility Criteria</h2>
        <div className="row text-center">
            {/* CARD 1 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/salaried-image-icon.png" 
                        alt="Eligibility" 
                        style={{ width: '200px', height: '200px' }}
                        className="mb-3"
                    />
                    <p className="text-center">Salaried/Working Professional</p>
                </div>
            </div>
            {/* CARD 2 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/age.png" 
                        alt="Age" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3" 
                    />
                    <p className="text-center">Age: 21-60 Years</p>
                </div>
            </div>
            {/* CARD 3 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/3-month-experienced.png" 
                        alt="Experience" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a job and a minimum of<br />3 months experience</p>
                </div>
            </div>
            {/* CARD 4 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/minimum-income_20000.png" 
                        alt="Income" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a minimum of Rs. 25,000<br />net income per month.</p>
                </div>
            </div>
        </div>
    </div>
</section>


{/*<!-- Apply Section -->*/}
<section id="apply" className="section bg-light text-center">
    <div className="container">
        <h2 className="mb-4">Ready to Start Your Journey With Best Home Loan Provider In Pune?</h2>
        <p>Apply now and let MortBuzz Solutions Advisory guide you to the Best Home Loan Provider In Pune With options.</p>
        <a href="apply-now" className="apply-btn-glass btn-lg mt-3">Apply for Home Loan</a>
    </div>
</section>



{/*<!-- Documentation Required Section -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Documentation Required for Home Loan In Pune</h2>
        <div className="row g-5">

            {/*<!-- Photo Identity Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        
                        <img src="/images/Bank Pages/photo-identy.png" alt="Photo-ID" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Photo Identity Proof for Home Loan in pune</h5>
                    </div>
                    <ul className= "text-white">
                        <li>Voter ID</li>
                        <li>Aadhaar Card</li>
                        <li>Passport</li>
                        <li>PAN Card</li>
                        <li>Driving Licence</li>
                    </ul>
                </div>
            </div>
          
            {/*<!-- Proof of Residence -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/proof-of-residence.png" alt="Address Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Proof of Residence for Home Loan</h5>
                    </div>
                    <ul className="text-white">
                        <li>Aadhaar Card</li>
                        <li>Driving Licence</li>
                        <li>Passport</li>
                        <li>Registered Rent Agreement</li>
                        <li>Latest Gas/Electricity Bill</li>
                        <li>Bank Statement with Current Address</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Income Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/income-proof.png" alt="Income Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Income Proof for home Loan</h5>
                    </div>
                    <ul className="text-white">
                        <li>Income Tax Returns (Last 3 Years)</li>
                        <li>Business License Details</li>
                        <li>Audited Balance Sheet & Profit/Loss (Last 3 Years)</li>
                        <li>Business Address Proof</li>
                        <li>6-Month Bank Statements (Current & Savings)</li>
                        <li>Copy of Form 16</li>
                        <li>6-Month Salary Account Statements</li>
                        <li>Last 3 Months’ Salary Slips</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Other Documents -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/other-document.png" alt="Other Documents" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Other Documents For Home Loan</h5>
                    </div>
                    <ul className="text-white" >
                        <li>Allotment Letter</li>
                        <li>Sale Deed</li>
                        <li>No Objection Certificate (NOC)</li>
                        <li>Allotment Letter from Society/Housing Board/Builder</li>
                        <li>Stamped Agreement of Sale</li>
                        <li>Possession Certificate</li>
                        <li>Construction Cost Estimate</li>
                        <li>Bank Payment Statement</li>
                        <li>Occupancy Certificate</li>
                        <li>Land Tax Receipt</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>\

{/*<!-- Application Process Section -->*/}
<section className="section bg-dark text-white py-5">
    <div className="container">
      <h2 className="text-center mb-5 text-white">Application Process</h2>
  
      <div className="timeline">
        {/*<!-- Step 1 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 1: Connect with Us</h4>
            <p>Explain your needs. We curate loan products most suitable for your profile.</p>
          </div>
        </div>
  
        {/*<!-- Step 2 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 2: Compare Loan Products</h4>
            <p>We help you compare several home loan products so you can choose the best one.</p>
          </div>
        </div>
  
       {/* <!-- Step 3 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 3: Apply Online</h4>
            <p>Pick a lender, apply online, and submit all necessary paperwork with our assistance.</p>
          </div>
        </div>
  
       {/* <!-- Step 4 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 4: Application Processing</h4>
            <p>The lender verifies your documentation and processes the application.</p>
          </div>
        </div>
  
        {/*<!-- Step 5 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 5: Receive Funds</h4>
            <p>Upon approval, the loan amount is credited directly to your account.</p>
          </div>
        </div>
  
      </div>
    </div>
  </section>


{/*<!-- Home Loan Rates Section -->*/}
<section className="section bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-5">Home Loan Lowest Interest Rates</h2>
  
      <div className="table-responsive">
        <table className="table table-hover table-striped shadow-lg rounded">
          <thead className="table-primary">
            <tr>
              <th>Bank Name</th>
              <th>Min. Rate of Interest (%)</th>
              <th>Loan Amount</th>
              <th>Loan Tenure</th>
              <th>Processing Fees</th>
              <th>Apply Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><a href="https://bankofindia.co.in/home-loan">Bank Of india</a></td>
              <td>7.35%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>1 years - 30 years</td>
              <td>Rs. 2,500/-</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.sc.com/in/loans/home-property-loans/home-loans/">Standard Chartered Bank</a></td>
              <td>8.95%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>1 years - 30 years</td>
              <td>0.50%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.idbibank.in/home-loan.aspx">IDBI Bank</a></td>
              <td>7.65%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>1 years - 30 years</td>
              <td>Rs. 5900/-</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://bankofmaharashtra.in/personal-banking/loans/home-loan">Bank Of Maharashtra</a></td>
              <td>7.35%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>1 years - 30 years</td>
              <td>Nill</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.centralbankofindia.co.in/en/node/417">Central Bank Of India</a></td>
              <td>7.35%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>1 years - 30 years</td>
              <td>0.25%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.axisbank.com/retail/loans/home-loan">Axis Bank</a></td>
              <td>8.35%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>1 years - 30 years</td>
              <td>Rs. 5,900/-</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.hdfc.com/">HDFC LTD</a></td>
              <td>7.90%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>1 years - 30 years</td>
              <td>Rs @590</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.kotak.com/en/personal-banking/loans/home-loan.html">Kotak Mahindra Bank</a></td>
              <td>7.99%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>1 years - 30 years</td>
              <td>Rs.11,800</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.bankofbaroda.in/personal-banking/loans/home-loan">Bank Of Baroda</a></td>
              <td>7.45%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>1 years - 30 years</td>
              <td>Nill</td>
              <td><a href="appy-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td> <a href="https://www.iob.in/home-loans.aspx">Indian Overseas Bank</a></td>
              <td>7.45%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>1 years - 30 years</td>
              <td>0.50%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.icicibank.com/personal-banking/loans/home-loan">ICICI Bank</a></td>
              <td>7.70%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>1 years - 30 years</td>
              <td>2% on Loan Amount</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>





<section className="section py-5 bg-dark">
  <div className="container">
    <div className="row align-items-center g-5">
      {/*<!-- Image Section -->*/}
      <div className="col-md-6 text-center">
        <img
          src="/images/FrontPage/loan-dealing.jpg"
          alt="Processing Fee"
          className="img-fluid rounded shadow"
        />
      </div>

      {/*<!-- Content Section -->*/}
      <div className="col-md-6">
        <h2 className="mb-4 text-primary" style={{ fontWeight: '700' }}>
          Processing Fee
        </h2>
        <p style={{ fontSize: '17px', color: '#FFEDFA' }}>
          Besides the <strong>home loan interest rate</strong>, you also need to pay a processing fee to your lender.
          This charge helps lenders cover the cost of verifying your documentation and processing your loan application.
        </p>
        <p style={{ fontSize: '17px', color: '#FBFBFB' }}>
          Typically, the processing fee ranges between <strong>1% to 2%</strong> of your total loan amount.
          Additionally, a <strong>GST of 18%</strong> is applicable on the fee.
        </p>
        <p style={{ fontSize: '17px', color: '#FBFBFB' }}>
          At <strong>MortBuzz Solutions Advisory</strong>, we help you find lenders who offer the <span style={{ color: '#007bff' }}>lowest processing fees</span> on home loans — ensuring you save more from the start.
        </p>

        <a href="/mortbuzz-home-loan-offer" className="apply-btn-glass mt-3">
          Get Best Offers
        </a>
      </div>
    </div>
  </div>
</section>


<section class="section bg-dark">
    <div class="container">
        <div class="row align-items-center">
           
            <div class="col-lg-6">
                <h2 class="mb-4 text-primary">MortBuzz Solutions Home Loan Balance Transfer</h2>
                <p class="text-white">If you’ve been paying hefty home loan EMIs and want to reduce your financial burden, consider a home loan balance transfer. A home loan balance transfer, or home loan refinancing, is a method of transferring your outstanding home loan balance from your existing lender to a new one. Yes, there are several benefits of home loan balance transfer. This facility can help you enjoy lower interest rates and better repayment terms. You can also get a top-up loan during the home loan balance transfer process if you need some extra cash.</p>
                <ul class="list-unstyled mt-3 text-white">
                    <li>✅ Lowest Interest Rates 7.85%*</li>
                    <li>✅ High Loan Amounts</li>
                    <li>✅ 360-Degree Assistance</li>
                    <li>✅ Zero Processing Fees on Selected Banks</li>
                    <li>✅ Upto 100% Cashback on Charges</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Fast Loan Processing</li>
                </ul>
            </div>

             <div class="col-lg-6 mb-4">
                <img src="/images/FrontPage/Balance Transfer.jpg" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
        </div>
    </div>
</section>




<div classname="w-100 px-3 px-md-5 py-5 bg-black text-white w-100 bg-black">
  <h2 className="text-center mb-5 display-4 fw-bold text-primary">Frequently Asked Questions</h2>

  <div className="row justify-content-center">
    <div className="col-lg-10 col-md-12">
      <div className="accordion" id="faqAccordion">

        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
              <i className="bi bi-question-circle me-3 text-primary fs-4"></i>
              ✅ Who can apply for a home loan with MortBuzz?
            </button>
          </h2>
          <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Anyone who is a salaried or self-employed individual with a stable income and good credit history can apply for a home loan with MortBuzz.
              <a href="apply-now" className="text-primary text-decoration-none">mortbuzz.in</a>. 
              We handle everything—no bank visit needed.
            </div>
          </div>
        </div>

        
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
              <i className="bi bi-percent me-3 text-primary fs-4"></i>
              🏡 What is the maximum loan amount I can get?
            </button>
          </h2>
          <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              The loan amount depends on factors like your income, repayment capacity, credit score, property value, and location. <strong className="text-success" MortBuzz offers/> One of the most competitive in the market. 
              <a href="https://mortbuzz.in" className="text-primary text-decoration-none">Check your eligibility</a> now.
            </div>
          </div>
        </div>

        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              💼 What documents are required to apply for a home loan?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
             Here's a quick list:
              <ul className="mt-2">
                <li><strong>PAN card & Aadhar card</strong> </li>
                <li><strong>Income proof (salary slips / ITR)</strong></li>
                <li><strong>Bank statements (last 6 months)</strong></li>
                  <li><strong>Property documents</strong></li>
                 <li><strong>Employment or business proof</strong></li>
              </ul>
            </div>
          </div>
        </div>

      
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              ⏱️ How long does it take to get loan approval?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
             With MortBuzz, you can get approval within 48 hours of submitting complete documentation. Final disbursement may take a few more days based on 
             property verification.
              
            </div>
          </div>
        </div>

        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              💰 What is the current interest rate?
            </button>
          </h2>
          <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              MortBuzz partners with top banks to offer competitive interest rates starting from 8.5% per annum. Exact rates depend on your eligibility.
              
            </div>
          </div>
        </div>


 
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              🚪 Do you offer doorstep services?
            </button>
          </h2>
          <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Yes! We provide doorstep document collection and loan consultation at no extra cost.
              
            </div>
          </div>
        </div>



        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq7">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              📉 What is the processing fee?
            </button>
          </h2>
          <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Processing fees vary by loan amount and lender but are often between 0.25% to 1%.
🎁 Limited-Time Cashback Offers available on processing fees!
              
            </div>
          </div>
        </div>

 
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq8">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              📜 Can I get a loan for under-construction property?
            </button>
          </h2>
          <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Yes. MortBuzz offers loans for ready-to-move, under-construction, and even resale properties.
              
            </div>
          </div>
        </div>



        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq9">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
               🔄 Can I transfer my existing home loan to MortBuzz?
            </button>
          </h2>
          <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Absolutely! We help with Balance Transfer to get you lower EMIs and better terms, often with zero processing fees.
              
            </div>
          </div>
        </div>


 
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq10">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              🧾 Can I prepay or foreclose my home loan?
            </button>
          </h2>
          <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Yes. Prepayment is allowed and often comes with zero or minimal charges, especially on floating-rate loans.
              <ul className="mt-2">
                <li><strong>Above ₹1 Cr:</strong> 100% cashback on fees.</li>
                <li><strong>₹90 Lakh:</strong> 90% cashback.</li>
                <li><strong>₹20 Lakh:</strong> 20% cashback.</li>
              </ul>
            </div>
          </div>
        </div>


 
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              How does the cashback offer work?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Cashback depends on your loan amount:
              <ul className="mt-2">
                <li><strong>Above ₹1 Cr:</strong> 100% cashback on fees.</li>
                <li><strong>₹90 Lakh:</strong> 90% cashback.</li>
                <li><strong>₹20 Lakh:</strong> 20% cashback.</li>
              </ul>
            </div>
          </div>
        </div>
       
        
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the process for obtaining a home loan from MortBuzz?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Apply at <a href="https://mortbuzz.in" class="text-primary">mortbuzz.in</a>.</li>
                <li>Our team will collect your documents.</li>
                <li>We handle approval with banks.</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>



    </>
  );
}

export default MortbuzzHomeLoan;
